module.exports = __webpack_public_path__ + "04eb98d15fb4377bdd6ba78f840da1fc.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/microsoft-proxy-voting-information.jpg
// module id = 1976
// module chunks = 0